import { Node } from './node';
import { compact } from 'lodash-es';

interface IArraySchema<TSchema> {
  items: TSchema[];
}

export abstract class ArrayNode<TSchema, TContext> extends Node<
  IArraySchema<TSchema>,
  TContext
> {
  abstract loadItem(
    item: TSchema,
    context: TContext,
  ): Promise<(() => Promise<void>) | void>;

  async load(context: TContext): Promise<void> {
    await this.beforeLoad(context);

    const afterLoadItemsCallbacks: (void | (() => Promise<void>))[] = [];

    if (!this.data?.items) return;

    for (const item of this.data.items) {
      try {
        afterLoadItemsCallbacks.push(await this.loadItem(item, context));
      } catch (e: unknown) {
        console.error('Array node step failed', e);
      }
    }

    for (const cb of afterLoadItemsCallbacks) {
      if (cb) {
        try {
          await cb();
        } catch (e: unknown) {
          console.error('Array node callback failed', e);
        }
      }
    }

    await this.afterLoad(context);
  }

  /**
   * Will be called before loading to do some data munging
   * @param context the context
   */
  async beforeLoad(context: TContext): Promise<void> {}

  /**
   * Will be called after all items are loaded
   * @param context the context
   */
  async afterLoad(context: TContext): Promise<void> {}
}
